import { Check } from "lucide-react";
import { TruncatedText } from "../components/truncated-text";

/** A pane's worth of choices, scrolling once there are more than fit. */
export function OptionList({ children }: { children: React.ReactNode }) {
  return <div className="scroll-fade max-h-72 overflow-y-auto">{children}</div>;
}

/** One choice in a list: what it is, and a tick when it is the one in effect. */
export function OptionRow({
  selected,
  onSelect,
  disabled = false,
  mark,
  name,
  description,
}: {
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
  mark?: React.ReactNode;
  name: string;
  description?: string;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      onClick={onSelect}
      className="flex w-full items-center gap-2.5 rounded-lg px-2 py-2 text-left transition hover:bg-foreground/10 active:scale-[0.99] disabled:pointer-events-none disabled:opacity-60"
    >
      {mark}
      <span className="min-w-0 flex-1">
        <TruncatedText text={name} className="text-sm" />
        {description && (
          <span className="block text-xs text-pretty text-muted-foreground">{description}</span>
        )}
      </span>
      {selected && <Check aria-hidden className="size-4 shrink-0" />}
    </button>
  );
}
